import { render, staticRenderFns } from "./ZeigeHerstellerKundenumsaetze.vue?vue&type=template&id=cde2ed12&"
import script from "./ZeigeHerstellerKundenumsaetze.vue?vue&type=script&lang=js&"
export * from "./ZeigeHerstellerKundenumsaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports